








































import { Component, Vue } from "vue-property-decorator";
import { requestResetPassword } from "@/api/user-api";

import AppHeader from "@/components/AppHeaderFake.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";

@Component({
  components: {
    AppHeader,
    ErrorAlert
  }
})
export default class LostPassword extends Vue {
  email = "";
  errors: string[] = [];

  sent = false;

  async submit() {
    try {
      await requestResetPassword(this.email);
      this.sent = true;
    } catch (errors) {
      this.errors = errors;
    }
  }
}
